import {MapEvent, DAY_NAMES} from "./Types";

function pad(n: number): string { return ('0' + n).slice(-2); }

export class Format {

    public static date(d: Date): string {
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}.`;
    }

    public static time(d: Date): string {
        return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    /** "10:00–18:00" ili samo "10:00" */
    public static timeRange(ev: MapEvent): string {
        let s = Format.time(new Date(ev.eventTime));
        if (ev.endTime) {
            s += '–' + Format.time(new Date(ev.endTime));
        }
        return s;
    }

    /** Tekst dana u nedelji za ponavljajući termin. */
    public static recurringDays(recurring: string): string {
        if (recurring === '1234500') return 'Радним данима';
        if (recurring === '0000067') return 'Викендом';
        if (recurring === '1234567') return 'Сваког дана';
        return DAY_NAMES.filter((_, i) => recurring[i] !== '0').join(', ');
    }

    /**
     * Pun opis termina za popup:
     *  - jednokratni:  "Сре, 02.09.2026. 10:00–18:00"
     *  - ponavljajući: "Радним данима 10:00–18:00 (до 20.09.2026.)"
     */
    public static schedule(ev: MapEvent): string {
        const range = Format.timeRange(ev);
        const d = new Date(ev.eventTime);
        const dayShort = ['Нед', 'Пон', 'Уто', 'Сре', 'Чет', 'Пет', 'Суб'][d.getDay()];
        // termin sa konkretnim datumom (jednokratni ili jedno ponavljanje)
        return `${dayShort}, ${Format.date(d)} ${range}`;
    }

    /** „понедељак, 14.09." – заглавље групе у вишедневном приказу. */
    public static dayLabel(d: Date): string {
        const days = ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'];
        return `${days[d.getDay()]}, ${pad(d.getDate())}.${pad(d.getMonth() + 1)}.`;
    }

    /** Опис понављања за детаље термина: „Радним данима 10:00–18:00 (до 21.09.2026.)". */
    public static recurrenceNote(ev: MapEvent): string | null {
        if (!ev.recurring || ev.recurring === '0000000') return null;
        let s = `${Format.recurringDays(ev.recurring)} ${Format.timeRange(ev)}`;
        if (ev.validUntil) {
            s += ` (до ${Format.date(new Date(ev.validUntil))})`;
        }
        return s;
    }

    /** Da li je termin danas već završen (samo za jednokratne/današnje prikaze). */
    public static endedToday(ev: MapEvent): boolean {
        if (!ev.endTime) return false;
        const end = new Date(ev.endTime);
        const now = new Date();
        return end.toDateString() === now.toDateString() && now > end;
    }

    public static placeLine(ev: MapEvent): string {
        if (ev.pointUuid) {
            return `${ev.pointName}, ${ev.pointAddress}`;
        }
        const parts = [ev.place, ev.address].filter(x => !!x);
        return parts.join(', ');
    }

    public static directionsUrl(lat: number, lon: number): string {
        return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`;
    }
}
